import store from '@/store/store';

export default {
  methods: {
    checkIfCurrentSociety(societeId) {
      const currentSocieteId = store.getters['societe/societeActiveId'];
      return societeId === currentSocieteId;
    },
  },
};
